import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Fit call, free',
    description: '30 minutes. We check whether AI is the right tool. If it is not, we say so.',
  },
  {
    number: '02',
    title: 'AI Audit, EUR 1,500',
    description: '5 days. We pick the best workflow, write the high-level design and the statement of work. The fee comes off the build.',
  },
  {
    number: '03',
    title: 'Build and run',
    description: 'Fixed price, your cloud. We build it, ship it and keep it running.',
  },
];

const ContactPage: React.FC = () => {
  return (
    <>
      <section className="section-padding bg-white">
        <div className="container-max">
          <h1 className="text-4xl md:text-5xl font-semibold text-black leading-[1.05] tracking-[-0.02em] mb-5 max-w-2xl">
            30 minutes. A straight answer.
          </h1>
          <p className="text-lg text-neutral-600 leading-relaxed max-w-2xl">
            Book a free fit call. We will check whether AI is the right tool for your problem and tell you honestly. If it is not, we say so.
          </p>
        </div>
      </section>

      <section className="section-padding bg-neutral-50">
        <div className="container-max">
          <h2 className="text-3xl font-semibold text-black tracking-tight mb-10">How it works</h2>
          <div className="grid md:grid-cols-3 gap-10">
            {steps.map((step) => (
              <div key={step.number}>
                <span className="text-4xl font-semibold text-neutral-200 block mb-4">{step.number}</span>
                <h3 className="text-xl font-semibold text-black mb-3 tracking-tight">{step.title}</h3>
                <p className="text-neutral-600 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-max">
          <div className="grid md:grid-cols-2 gap-10">
            <div>
              <h2 className="text-3xl font-semibold text-black tracking-tight mb-8">Get in touch</h2>
              <div className="space-y-4">
                <a
                  href="mailto:contact@zwiftlabs.com"
                  className="flex items-center gap-3 bg-white rounded-2xl px-6 py-5 border border-neutral-200 hover:border-neutral-900 transition-colors"
                >
                  <svg className="w-5 h-5 text-neutral-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span className="text-neutral-800 font-medium">contact@zwiftlabs.com</span>
                </a>
                <a
                  href="tel:+353899831792"
                  className="flex items-center gap-3 bg-white rounded-2xl px-6 py-5 border border-neutral-200 hover:border-neutral-900 transition-colors"
                >
                  <svg className="w-5 h-5 text-neutral-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <span className="text-neutral-800 font-medium">+353 89 983 1792</span>
                </a>
                <div className="flex items-center gap-3 bg-white rounded-2xl px-6 py-5 border border-neutral-200">
                  <svg className="w-5 h-5 text-neutral-400 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="text-neutral-800 font-medium">Dublin, Ireland. Serving the EU, UK and US.</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col justify-center gap-4">
              <a
                href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-black hover:bg-neutral-800 text-white font-medium px-7 py-4 rounded-full transition-colors text-lg"
              >
                Book a fit call
              </a>
              <a
                href="mailto:contact@zwiftlabs.com"
                className="inline-flex items-center justify-center bg-white hover:bg-neutral-50 text-black border border-neutral-200 hover:border-neutral-900 font-medium px-7 py-4 rounded-full transition-colors text-lg"
              >
                Email the founders
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
